/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { Theme, useTheme } from 'bold-ui'
import { SimNaoRadioListField, SimNaoRadioListFieldProps } from 'components/form/field/SimNaoRadioListField'
import { MetaPath } from 'util/metaPath'

import { ConsultaSeguimentoOutroFieldModel } from '../model-consultaSeguimento'
import { PerguntaSimNaoOutroRadioListField } from './PerguntaSimNaoRadioOutroListField'

type PerguntaSimNaoRadioListFieldProps<T extends string> = Omit<SimNaoRadioListFieldProps<T>, 'labelStyle'> & {
  nameOutro?: MetaPath<ConsultaSeguimentoOutroFieldModel>
  hideOutrosFieldRadioOptions?: boolean
}

export function PerguntaSimNaoRadioListField<T extends string>(props: Readonly<PerguntaSimNaoRadioListFieldProps<T>>) {
  const { label, nameOutro, hideOutrosFieldRadioOptions, ...rest } = props

  const theme = useTheme()
  const styles = createStyles(theme)

  if (nameOutro) {
    return (
      <PerguntaSimNaoOutroRadioListField
        label={<span>“{label}”</span>}
        labelStyle={styles.label}
        nameOutro={nameOutro}
        hideOutrosFieldRadioOptions={hideOutrosFieldRadioOptions}
        {...rest}
      />
    )
  }

  return <SimNaoRadioListField label={<span>“{label}”</span>} labelStyle={styles.label} {...rest} />
}

const createStyles = (theme: Theme) => ({
  label: css`
    color: ${theme.pallete.primary.main};
  `,
})
